import * as React from "react"

const Plus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M8.5 4.5V4h-1v3h-3v1h3v3h1V8h3V7h-3V4.5Z" />
  </svg>
)

export default Plus
